import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { GIButton, Modal } from 'app-components';

import { ModalContextType } from '@contexts/modalContext';
import { configs } from '@constants/configs/configs';

import { StyledModalButtonFooter } from '../voterRegistration.styled';

interface IModalProps extends ModalContextType {
    onClose?: () => void;
}

const VoterRegistrationEligibilityWarningModal = ({ closeAllModals, onClose }: IModalProps) => {
    const navigate = useNavigate();

    const onContinue = () => {
        closeAllModals();
        navigate(configs.routes.INDPORTAL);
    };

    const onCloseModal = () => {
        closeAllModals();
        onClose?.();
    };

    return (
        <Modal id="voter_registration_eligibility_warning_modal">
            <Modal.Header
                id="voter_eligibility_warning_modal_header"
                titleId="voterRegistration.form.modal.eligibilityWarning.header"
                onHide={onCloseModal}
            />
            <Modal.Body>
                <p>
                    <FormattedMessage id="voterRegistration.form.modal.eligibilityWarning.body" />
                </p>
            </Modal.Body>
            <Modal.Controls>
                <StyledModalButtonFooter>
                    <GIButton
                        id="voter_eligibility_warning_go_back_btn"
                        labelId="button.go_back"
                        variant="secondary"
                        onClickHandler={onCloseModal}
                    />
                    <GIButton
                        id="voter_eligibility_warning_continue_btn"
                        labelId="button.continue"
                        variant="primary"
                        onClickHandler={onContinue}
                    />
                </StyledModalButtonFooter>
            </Modal.Controls>
        </Modal>
    );
};

export default VoterRegistrationEligibilityWarningModal;
